<template>
	<div :class="showContent ? 'container':'container-ac'">
		<div class="content" v-show="showContent">
			<div class="train-content">
				<img src="../assets/images/train-bg.png" alt="" class="train-bg">
				<div class="train-main">
					<div class="train-title">{{trainName}}</div>
					<div class="time-box">
						<div class="time-long">
							<img src="../assets/images/emotion_time.png" alt="" srcset="" class="time-icn">
							<div class="long">时长</div>
						</div>
						<div class="time-text">60分钟</div>
					</div>
					<div class="train-des">如果您是一位有经验的练习者并自备了训练材料，
						请点击下方【开始】按钮进行自由练习，彼馨将为您全程记录情绪数据。
						<br />
						<span style="color: #000;">注意事项:</span>
						<ul class="ulstyle">
							<li>练习过程中可退出页面，彼馨将在后台持续为您检测情绪数据。</li>
							<li>练习结束后请返回该页面手动点击结束，并查看情绪检测结果。</li>
							<li>情绪检测至多持续60分钟，达到60分钟将自动停止并生成检测结果。</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="go">
				<div class="go-box">
					<div class="go-btn" @click="start">开始</div>
				</div>
			</div>
		</div>
		<div class="main" v-show="!showContent">
			<div class="train-pic">
				<img src="../assets/images/recommended-pic.webp" alt="" />
			</div>
			<div class="train-name">{{trainName}}</div>
			<div class="step-box">
				<div class="step">
					<div class="step-line" :style="{ width: press + '%' }"></div>
					<div class="step-dot" :style="{ left: (press / 100) * 250 - 6 + 'px' }"></div>
				</div>
				<div class="now-all">
					<div class="now">{{ nowTime }}</div>
					<div class="all">{{ allTime }}</div>
				</div>
			</div>
			<div class="go">
				<div class="" style="padding: 15px;">
					<div class="go-btn" style="margin: 5px 0;" @click="toquit(1)">结束练习</div>
					<div class="go-btn-canel" @click="toquit(0)">暂时退出</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		add_train
	} from '../api/server'
	import {
		Dialog,
	} from 'vant';
	export default {
		components: {
			[Dialog.Component.name]: Dialog.Component,
		},
		data() {
			return {
				showContent: true,
				imei: '',
				loginPhone: '',
				nowControl: "play",
				allTime: "",
				nowTime: "00:00",
				press: "",
				startTime: 0,
				endTime: '',
				trainName: '自由练习',
				timerVar: null,
				exerciseAlltime: 3600,
				exerciseNewTime: 0,
				exerciseStartTime:0
			};
		},
		computed: {},
		methods: {
			toquit(q) {
				//暂时退出
				if (q == 0) {
					Dialog.confirm({
						title: '暂时退出',
						message: `暂时退出后，仍将在后台持续检测情绪数据，练习完毕后请返回并手动结束练习`,
						confirmButtonText: "确认退出"
					}).then(() => {
						this.$router.go(-1)
					}).catch(()=>{
						})
				}
				//结束练习
				if (q == 1) {
					let exerciseStartTime = localStorage.getItem('exerciseStartTime');
					let endtime = new Date().getTime() / 1000;
					let starttime = parseInt(exerciseStartTime / 1000)
					if (endtime - starttime < 300) {
						return Dialog.confirm({
							title: '结束练习',
							message: `当前练习时间较短，是否确认结束练习？
结束后将无法生成训练结果报告`,
							confirmButtonText: "确认结束"
						}).then(() => {
							localStorage.removeItem('exerciseStartTime')
							this.$router.push({
								path: '/service'
							})
						}).catch(()=>{
						})
					}
					Dialog.confirm({
						title: '结束练习',
						message: `是否确认结束练习？
结束后将生成训练结果报告`,
						confirmButtonText: "确认结束"
					}).then(() => {
						this.exerciseOver()
					}).catch(()=>{
						})
				}
			},
			exerciseOver() {
				let exerciseStartTime = localStorage.getItem('exerciseStartTime');
				let endtime = parseInt(new Date().getTime() / 1000);
				let starttime = parseInt(exerciseStartTime / 1000)
				if (endtime - starttime < 600) {
					this.$toast('练习时间过短,暂无数据！');
					localStorage.removeItem('exerciseStartTime')
					return this.$router.push({
						path: '/service'
					})
				}
				if (!exerciseStartTime && exerciseStartTime == 0) {
					return this.$toast('开始时间已失效！s:' + exerciseStartTime || '');
				}
				add_train(this.loginPhone, this.imei, starttime, endtime, 'train', this.trainName).then(res => {
					if (res.status == 200) {
						this.$router.push({
							path: '/train-report',
							query: {
								id: res.data.trainData[0].id
							}
						})
					} else {
						this.$toast('网络错误~');
					}
					localStorage.removeItem('exerciseStartTime')

				})
			},
			startExercise() {
				let exerciseStartTime = localStorage.getItem('exerciseStartTime');
				let nowTimess = new Date().getTime();
				if (exerciseStartTime) {
					let startTime = parseInt(exerciseStartTime / 1000);
					let timeing = parseInt((nowTimess - exerciseStartTime) / 1000)
					this.exerciseNewTime = timeing
					if (timeing >= 3600) {
						let endtime = parseInt(exerciseStartTime/1000) + 3600;
						return add_train(this.loginPhone, this.imei, startTime, endtime, 'train', this.trainName)
							.then(res => {
								if (res.status == 200) {
									localStorage.removeItem('exerciseStartTime')
									this.$router.push({
										path: '/train-report',
										query: {
											id: res.data.trainData[0].id
										}
									})
								} else {
									this.$toast('网络错误~');
								}
							})
					} else {
						this.exerciseAlltime -= timeing;
					}
				} else {
					console.log(1);
					localStorage.setItem('exerciseStartTime', new Date().getTime())
					this.startTime = new Date().getTime() / 1000;
				}
				this.trainName = '自由练习'
				this.allTime = '60:00'
				let that = this
				this.timerVar = setInterval(() => {
					this.exerciseAlltime -= 1;
					this.exerciseNewTime += 1;
					that.update();
					if (this.exerciseAlltime <= 0) {
						this.exerciseAlltime = 0;
						clearInterval(this.timerVar)
					}
				}, 1000)
			},
			goBack() {
				this.$router.go(-1)
			},
			start() {
				console.log("start");
				this.showContent = false;
				this.startExercise()
			},
			update() {
				let time = 0;
				let nowTime = 0;
					nowTime = this.exerciseNewTime
					time = 3600
			
				let minutesA = parseInt(nowTime / 60);
				if (minutesA < 10) {
					minutesA = "0" + minutesA;
				}
				let secondA = Math.round(nowTime % 60);
				if (secondA < 10) {
					secondA = "0" + secondA;
				}
				let startTime = minutesA + ":" + secondA;
				this.nowTime = startTime;
				let press = (nowTime / time) * 100;
				this.press = press;
			},
		},
		created() {
			let imei = localStorage.getItem('imei');
			this.imei = imei;
			let phone = localStorage.getItem('phone');
			this.loginPhone = phone;
			let exerciseStartTime = localStorage.getItem('exerciseStartTime');
			if (exerciseStartTime) {
				this.start()
			}
		}
	};
</script>
<style lang='less' scoped>
	.container {
		height: 100vh;
		width: 100vw;
	}

	.container-ac {
		height: 100vh;
		width: 100vw;
		background-color: rgba(49, 59, 59, 0.3);
	}

	.content {
		padding: 16px;
	}

	.train-content {
		background-color: #fff;
		border-radius: 10px;
	}

	.train-bg {
		display: block;
		width: 100%;
		height: 142px;
		border-radius: 10px 10px 0px 0px;
	}

	.train-main {
		padding: 12px;
		border-radius: 0px 0px 10px 10px;
	}

	.train-title {
		margin-top: 8px;
		margin-bottom: 20px;
		line-height: 20px;
		font-size: 20px;
		font-weight: 500;
		color: #333;
	}

	.time-box {
		height: 40px;
		background-color: #FBFCFC;
		border-radius: 20px;
		padding: 0px 12px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.time-long {
		margin-top: 8px;
		height: 24px;
		display: flex;
		justify-content: flex-start;
	}

	.time-icn {
		height: 24px;
		width: 24px;
	}

	.long {
		height: 24px;
		line-height: 24px;
		font-size: 12px;
		color: #999999;
		margin-left: 8px;
	}

	.time-text {
		margin-top: 8px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		font-weight: 500;
		color: #333;
	}

	.train-des {
		line-height: 26px;
		font-size: 14px;
		color: #666666;
		text-indent: 2em;
	}

	.go {
		position: fixed;
		left: 0px;
		bottom: 0px;
		width: 100%;
		z-index: 10;
	}

	.go-box {
		background-color: #fff;
		padding: 10px 16px;
	}

	.go-btn {
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
		background-color: #01D6D6;
	}

	@media (min-width: 768px) {

		/*0~768*/
		.go-box {
			width: 400px;
			margin: 0 auto;
		}
	}

	.main {
		padding-top: 90px;
	}

	.train-pic {
		height: 180px;
		width: 180px;
		margin: 0 auto;
		border-radius: 50%;
		border: 2px solid #fff;
	}

	.train-pic img {
		display: block;
		height: 180px;
		width: 180px;
		border-radius: 50%;
	}

	.train-name {
		height: 60px;
		line-height: 60px;
		text-align: center;
		font-size: 20px;
		font-weight: 500;
		color: #fff;
		margin-bottom: 104px;
	}

	.control {
		height: 80px;
		margin-bottom: 90px;
	}

	.play {
		display: block;
		height: 80px;
		width: 80px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.pause {
		display: block;
		height: 80px;
		width: 80px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.step-box {
		width: 250px;
		margin: 0 auto;
	}

	.step {
		height: 4px;
		background-color: #777871;
		border-radius: 2px;
		position: relative;
	}

	.step-line {
		height: 4px;
		position: absolute;
		left: 0px;
		top: 0px;
		background-color: #fff;
		width: 0px;
	}

	.step-dot {
		height: 12px;
		width: 12px;
		border-radius: 50%;
		background-color: #fff;
		position: absolute;
		left: -6px;
		top: -4px;
	}

	.now-all {
		margin-top: 8px;
		display: flex;
		justify-content: space-between;
	}

	.now {
		height: 12px;
		line-height: 12px;
		font-size: 10px;
		font-weight: 900;
		color: #fff;
	}

	.all {
		height: 12px;
		line-height: 12px;
		font-size: 10px;
		font-weight: 900;
		color: #fff;
	}

	.music {
		display: none;
	}

	.ulstyle {
		list-style: decimal inside;
	}

	.go-btn-canel {
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
		background-color: none;
	}
</style>
